import { Restoration } from "./restoration";
import { Post } from "./post";
import { Splint } from "./splint";
import { ExternalBleach } from "./external-bleach";
import { InternalBleach } from "./internal-bleach";
import { CoreBuildUp } from "./core-build-up";
import { ProvisionalRestoration } from "./provisional-restoration";

export const treatments = [
  Restoration,
  Post,
  Splint,
  ExternalBleach,
  InternalBleach,
  CoreBuildUp,
  ProvisionalRestoration,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/restorative/index.ts